webpackJsonp([167332098027474],{

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(40);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 2: Display New Tweets'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll display new tweets at the top of the Feed.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'optimistic.2' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'What\'s the problem?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Currently, when we create new tweets, we have to refresh the page before they appear, which is not a very good user experience. A better experience would be to have new tweets automatically show up at the top of the Feed.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Why does this happen?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This happens because the application doesn\'t know what to do with the new tweets you create, since that answer is determined based on the experience you\'re creating.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For this type of experience, we want new tweets to appear at the top of the page, otherwise the application will feel "out of date" very quickly. But for other applications, it might not be as straight forward.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, should new tweets show up at all? If yes, where should they show up? At the top of the list? The bottom of the list? Should ALL new tweets show up, or just some? And if you DO want them to show up, should they show up immediately, or wait until the server confirms they\'be been created?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Because of that uncertainty, Lore doesn\'t make any assumptions about what to do with "new data", and only gives you exactly what you ask for. And in this case, all we asked for was first page of tweets.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'But it DOES give you some tools to easily describe the answers to those questions, and we\'ll be leveraging those tools in this step to shape the experience into what we want.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Chose the Location for New Tweets'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'InfiniteScrollingList'
	      ),
	      ' component we created earlier actually has a section that allows you to put "other" data at the top of the list. The relevant section of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method is shown below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // src/components/InfiniteScrollingList.js\n      render() {\n        ...\n        return (\n          <div>\n            <ul className="media-list tweets">\n              {other ? other.data.map(row) : null}\n              // ...\n            </ul>\n            // ...\n          </div>\n        );\n      }\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Display New Tweets'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To get tweets to appear here, we simply need to provide the "other" data to the list. Open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component and update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // src/components/Feed.js\n      import moment from \'moment\';\n      ...\n      render() {\n        ...\n        return (\n          <div className="feed">\n            ...\n            <InfiniteScrollingList\n              ...\n              selectOther={(getState) => {\n                return getState(\'tweet.all\', {\n                  where: function(tweet) {\n                    const isReal = tweet.id;\n                    const isNew = moment(tweet.data.createdAt).diff(timestamp) > 0;\n                    return isReal && isNew;\n                  },\n                  sortBy: function(model) {\n                    return -moment(model.data.createdAt).unix();\n                  }\n                });\n              }}\n            />\n          </div>\n        );\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here we\'ve provided a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'selectOther()'
	      ),
	      ' prop to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'InfiniteScrollingList'
	      ),
	      ', which allows us to return an array of data that we want to be displayed at the top of the list.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To do this, we\'re introducing a new ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getState()'
	      ),
	      ' mapping called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.all'
	      ),
	      ', which allows you to search through all tweets in the store, and extract a subset. To narrow down the results, there are two properties you can provide; ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'where()'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'sortBy()'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'where()'
	      ),
	      ' method is where we specify our matching criteria. In this case, we want any tweets created AFTER the timestamp we\'re using to freeze the pagination data, as well as any tweets that don\'t yet have an id (which means the user just created them, and the server has not yet confirmed).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'sortBy()'
	      ),
	      ' method allows us to express how we want those tweets to be ordered, and in this case, we want the newest tweets on top.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Try it Out'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With that change in place, new tweets will show up at the top of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' shortly after you create them. You\'ll notice however that there\'s a shortly delay between the time you create a tweet and when it actually shows up in the list.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the next step, we\'ll learn why this happens and to remove it.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this (exactly the same).'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Feed.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import _ from \'lodash\';\n        import moment from \'moment\';\n        import InfiniteScrollingList from \'./InfiniteScrollingList\';\n        import Tweet from \'./Tweet\';\n\n        export default createReactClass({\n          displayName: \'Feed\',\n\n          getInitialState() {\n            return {\n              timestamp: new Date().toISOString()\n            };\n          },\n\n          render() {\n            const { timestamp } = this.state;\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <InfiniteScrollingList\n                  select={(getState) => {\n                    return getState(\'tweet.find\', {\n                      where: {\n                        where: {\n                          createdAt: {\n                            \'<=\': timestamp\n                          }\n                        }\n                      },\n                      pagination: {\n                        sort: \'createdAt DESC\',\n                        page: 1\n                      }\n                    });\n                  }}\n                  row={(tweet) => {\n                    return (\n                      <Tweet key={tweet.id} tweet={tweet} />\n                    );\n                  }}\n                  refresh={(page, getState) => {\n                    return getState(\'tweet.find\', page.query);\n                  }}\n                  selectNextPage={(lastPage, getState) => {\n                    const lastPageNumber = lastPage.query.pagination.page;\n\n                    return getState(\'tweet.find\', _.defaultsDeep({\n                      pagination: {\n                        page: lastPageNumber + 1\n                      }\n                    }, lastPage.query));\n                  }}\n                  selectOther={(getState) => {\n                    return getState(\'tweet.all\', {\n                      where: function(tweet) {\n                        const isReal = tweet.id;\n                        const isNew = moment(tweet.data.createdAt).diff(timestamp) > 0;\n                        return isReal && isNew;\n                      },\n                      sortBy: function(model) {\n                        return -moment(model.data.createdAt).unix();\n                      }\n                    });\n                  }}\n                />\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import _ from \'lodash\';\n        import moment from \'moment\';\n        import InfiniteScrollingList from \'./InfiniteScrollingList\';\n        import Tweet from \'./Tweet\';\n\n        class Feed extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.state = {\n              timestamp: new Date().toISOString()\n            };\n          }\n\n          render() {\n            const { timestamp } = this.state;\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <InfiniteScrollingList\n                  select={(getState) => {\n                    return getState(\'tweet.find\', {\n                      where: {\n                        where: {\n                          createdAt: {\n                            \'<=\': timestamp\n                          }\n                        }\n                      },\n                      pagination: {\n                        sort: \'createdAt DESC\',\n                        page: 1\n                      }\n                    });\n                  }}\n                  row={(tweet) => {\n                    return (\n                      <Tweet key={tweet.id} tweet={tweet} />\n                    );\n                  }}\n                  refresh={(page, getState) => {\n                    return getState(\'tweet.find\', page.query);\n                  }}\n                  selectNextPage={(lastPage, getState) => {\n                    const lastPageNumber = lastPage.query.pagination.page;\n\n                    return getState(\'tweet.find\', _.defaultsDeep({\n                      pagination: {\n                        page: lastPageNumber + 1\n                      }\n                    }, lastPage.query));\n                  }}\n                  selectOther={(getState) => {\n                    return getState(\'tweet.all\', {\n                      where: function(tweet) {\n                        const isReal = tweet.id;\n                        const isNew = moment(tweet.data.createdAt).diff(timestamp) > 0;\n                        return isReal && isNew;\n                      },\n                      sortBy: function(model) {\n                        return -moment(model.data.createdAt).unix();\n                      }\n                    });\n                  }}\n                />\n              </div>\n            );\n          }\n\n        }\n\n        export default Feed;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import _ from \'lodash\';\n        import moment from \'moment\';\n        import InfiniteScrollingList from \'./InfiniteScrollingList\';\n        import Tweet from \'./Tweet\';\n\n        class Feed extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.state = {\n              timestamp: new Date().toISOString()\n            };\n          }\n\n          render() {\n            const { timestamp } = this.state;\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <InfiniteScrollingList\n                  select={(getState) => {\n                    return getState(\'tweet.find\', {\n                      where: {\n                        where: {\n                          createdAt: {\n                            \'<=\': timestamp\n                          }\n                        }\n                      },\n                      pagination: {\n                        sort: \'createdAt DESC\',\n                        page: 1\n                      }\n                    });\n                  }}\n                  row={(tweet) => {\n                    return (\n                      <Tweet key={tweet.id} tweet={tweet} />\n                    );\n                  }}\n                  refresh={(page, getState) => {\n                    return getState(\'tweet.find\', page.query);\n                  }}\n                  selectNextPage={(lastPage, getState) => {\n                    const lastPageNumber = lastPage.query.pagination.page;\n\n                    return getState(\'tweet.find\', _.defaultsDeep({\n                      pagination: {\n                        page: lastPageNumber + 1\n                      }\n                    }, lastPage.query));\n                  }}\n                  selectOther={(getState) => {\n                    return getState(\'tweet.all\', {\n                      where: function(tweet) {\n                        const isReal = tweet.id;\n                        const isNew = moment(tweet.data.createdAt).diff(timestamp) > 0;\n                        return isReal && isNew;\n                      },\n                      sortBy: function(model) {\n                        return -moment(model.data.createdAt).unix();\n                      }\n                    });\n                  }}\n                />\n              </div>\n            );\n          }\n\n        }\n\n        export default Feed;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the next section we\'ll ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-3/' },
	        'remove the delay between creating a tweet and when it appears in the Feed'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-optimistic-step-2-js-0a4df6bf43713e2feba7.js